import { Spinner } from '@ui-kitten/components';
export default Spinner;
//# sourceMappingURL=Spinner.js.map